import {v4 as uuid } from 'uuid';
function updateOptinValues (p) {
    const fields = Object.keys(p);
    this.updateTouched(fields);
    this.optinValues = {
        ...this.optinValues,
        ...p,
    };
    this.captureFields();
    this.observed.optinValues = uuid();
}

export default updateOptinValues;